(() => {
    const groups = {
      fresh: ['abd','cyrnos','figuerie','reggio','salta','under','versailles','deoro'],
      flowers: ['josephine','madurai','tuileries','positano','rose','odalisque','vesta','atria','luna','arosa','summer'],
      woods: ['ernesto','solis','altair','madeleine','hemera','fir','figuerie'],
      warm: ['gabriel','cire','nazareth','gloria','angelo','libra','summer']
    };
    const normalize = text => text.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/['’]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    const wordGroups = [
      ['smoke','smoky','smokey','smoked','smokiness'],
      ['tobacco','tabacco','tabaco','tobaco','tobbaco','tobbacco'],
      ['chimney','chimmney','chimeny'],
      ['fireplace','fireside','hearth'],
      ['woodsmoke','woodsmoky'],
      ['wood','woody','woods'],
      ['herb','herbs','herbal'],
      ['flower','flowers','floral','florals'],
      ['earth','earthy','soil'],
      ['leaf','leaves','leafy'],
      ['fruit','fruits','fruity'],
      ['berry','berries'],
      ['powder','powdery'],
      ['citrus','citrusy','citrussy'],
      ['sweet','sweetness'],
      ['cosy','cozy','comforting'],
      ['mint','minty'],
      ['musk','musky','musks'],
      ['resin','resinous','resins'],
      ['rose','roses'],
      ['spice','spices','spicy'],
      ['pepper','peppery','peppercorn'],
      ['chestnut','chestnuts'],
      ['cedar','cedarwood'],
      ['sandalwood','sandal'],
      ['oud','oudh','agarwood']
    ];
    const aliases = new Map(wordGroups.flatMap(words => words.map(word => [word, words[0]])));
    const tokens = text => normalize(text).split(/\s+/).filter(Boolean).map(word => aliases.get(word) || word);
    const fillers = new Set(['a','an','and','the','of','for','with','like','smell','smells','smelling','scent','scents','fragrance','fragrances','candle','candles','trudon','something','me','reminds']);
    const indexProfiles = profiles => profiles.forEach(profile => {
      profile.searchIndex = {
        name: tokens(profile.name),
        primary: tokens(`${profile.name} ${profile.notes} ${profile.search}`),
        related: tokens(`${profile.name} ${profile.notes} ${profile.search} ${profile.associations}`),
        prose: tokens(`${profile.name} ${profile.descriptor} ${profile.body} ${profile.notes} ${profile.search} ${profile.associations}`),
        phrases: profile.search.split('|').map(phrase => tokens(phrase).join(' '))
      };
    });
    const searchRank = (profile, words, partial = false) => {
      const index = profile.searchIndex;
      const matches = field => words.every((word, position) => field.some(candidate => candidate === word || (partial && position === words.length - 1 && word.length >= 3 && candidate.startsWith(word))));
      const phrase = words.join(' ');
      if (index.name.join(' ') === phrase) return 1000;
      if (matches(index.name)) return 800;
      if (index.phrases.includes(phrase)) return 500 + Math.max(0, 50 - index.phrases.indexOf(phrase));
      if (matches(index.primary)) return 400;
      if (matches(index.related)) return 250;
      if (matches(index.prose)) return 100;
      return 0;
    };

 window.TrudonScent = {groups, tokens, fillers, indexProfiles, searchRank};
})();
